import ExlyModal from "common/Components/ExlyModal";
import React from "react";
import { CustomFooterContext } from "../..";
import commonStyle from "../../../../../style.module.css";
import { Input } from "@my-scoot/component-library-legacy";
import moduleStyle from "./AddLineModal.module.css";
import { FORM_KEYS, SECTION_SIDE_KEYS } from "../../CustomFooter.constants";
import { ExlyDropdown } from "common/form";
import { is_empty, validURLV2 } from "utils/validations";

export const AddLineModal = () => {
  const {
    data,
    show_modal,
    handleModalClose,
    processing,
    handleSave,
    error_object,
    selected_record,
    set_error_object,
    addItem,
    updateData,
  } = React.useContext(CustomFooterContext);

  const [section_side, set_section_side] = React.useState(null);

  // in edit case, to prefill side dropdownm when selected_record is populated
  React.useEffect(() => {
    if (is_empty(section_side) && !is_empty(selected_record?.section_side)) {
      set_section_side(selected_record.section_side);
    }
  }, [selected_record?.section_side]);

  return (
    <ExlyModal
      title="Add new line"
      open={show_modal}
      onClose={handleModalClose}
      primaryBtnText={processing ? "..." : "Save"}
      onPrimaryBtnClick={() => handleSave({ section_side })}
      modal_props={{
        modalPaperClassName: moduleStyle.miscellaneous_data_modal,
      }}
    >
      <div className={`pt-4 pb-4`}>
        <div className={`${commonStyle.label} ${commonStyle.required} mb-1`}>
          {FORM_KEYS.section_side.label}
        </div>
        <ExlyDropdown
          fullWidth
          meta={{}}
          input={{
            value: section_side,
            onChange: (value) => {
              if (error_object?.[FORM_KEYS.section_side.key]) {
                set_error_object({
                  ...error_object,
                  [FORM_KEYS.section_side.key]: false,
                });
              }
              set_section_side(value);
              addItem(value);
            },
          }}
          options={Object.values(SECTION_SIDE_KEYS).map((item) => ({
            ...item,
            value: item.key,
          }))}
          size="small"
          placeholder="Select side"
        />

        <div
          className={`${commonStyle.label} ${commonStyle.required} mt-3 mb-1`}
        >
          {FORM_KEYS.text.label}
        </div>
        <Input
          error={error_object?.[FORM_KEYS.text.key]}
          helperText={error_object?.[FORM_KEYS.text.key] ? "Invalid" : null}
          fullWidth
          disabled={is_empty(section_side)}
          value={
            data?.[section_side]?.[selected_record.id]?.[FORM_KEYS.text.key]
          }
          onChange={(e) => {
            if (error_object?.[FORM_KEYS.text.key]) {
              set_error_object({
                ...error_object,
                [FORM_KEYS.text.key]: false,
              });
            }
            let value = e.target.value;
            updateData(value, FORM_KEYS.text.key, section_side);
          }}
        />

        <div className={`${commonStyle.label} mt-3 mb-1`}>
          {FORM_KEYS.link.label}
        </div>
        <Input
          error={error_object?.[FORM_KEYS.link.key]}
          helperText={error_object?.[FORM_KEYS.link.key] ? "Invalid" : null}
          fullWidth
          disabled={is_empty(section_side)}
          value={
            data?.[section_side]?.[selected_record.id]?.[FORM_KEYS.link.key]
          }
          onChange={(e) => {
            if (error_object?.[FORM_KEYS.link.key]) {
              set_error_object({
                ...error_object,
                [FORM_KEYS.link.key]: false,
              });
            }
            let value = e.target.value;
            if (!is_empty(value) && !validURLV2(value)) {
              set_error_object({ ...error_object, [FORM_KEYS.link.key]: true });
            }
            updateData(value, FORM_KEYS.link.key, section_side);
          }}
        />
      </div>
    </ExlyModal>
  );
};
